/* this file added by Bearer Web Developer  */
import React, { useState } from 'react';
import styles from './apiDevProvider.module.scss';
import { useAppState } from '../../../../../states/app-state';
import AddMenu from './addMenu';
import { observer } from 'mobx-react-lite';
import RemoveConfirm from './../removeConfirm';
import DisabledClickLoading from '../../../../../components/DisabledClickLoading';
import { useThemeMode } from '../../../../../states/contexts/theme';

const ApiDevProvider: React.FC = observer(() => {
    const appState = useAppState();
    const allowed_intermediate_api_providers = appState?.ApiIntegration?.apiIntegrationData?.allowed_intermediate_api_providers;
    const intermediate_api_providers = appState?.ApiIntegration?.apiIntegrationData?.intermediate_api_providers;
    const [loading, setLoading] = useState(false);
    const removeProvider = async (v: string) => {
        setLoading(true)
        await appState?.ApiIntegration?.fetchUpdateProvidersApiIntegration(
            [
                ...(allowed_intermediate_api_providers || []), // data cannot be deleted 
                ...(intermediate_api_providers?.filter(p => p !== v) || [])// data can be deleted (remove item)
            ]
        );
        setLoading(false)
    }
    // RemoveConfirm start
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClickOpenRemoveConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // RemoveConfirm end
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.api_dev_provider} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.header}>
                <h3>API Dev Provider</h3>
                <AddMenu setLoading={setLoading} />
            </div>
            <div className={styles.list}>
                <ul>
                    {allowed_intermediate_api_providers?.map((v, i) => (<li key={i}>{v}</li>))} {/* data cannot be deleted */}
                    {intermediate_api_providers?.map((v, i) => (
                        <li key={i}>
                            {v}
                            <span onClick={handleClickOpenRemoveConfirm} className={styles.delete}>
                                {
                                    theme === "dark" ?
                                        <img width={15} height={14} src="/backspace-delete-white.svg" alt="X" />
                                        :
                                        <img width={15} height={14} src="/backspace-delete.webp" alt="X" />
                                }
                            </span>
                            <RemoveConfirm anchorEl={anchorEl}
                                handleDelete={() => { removeProvider(v) }}
                                handleClose={handleClose} open={open} valueItem={v} />
                        </li>
                    ))} {/* data can be deleted */}
                </ul>
            </div>
            {loading && <DisabledClickLoading />}
        </div>
    )
})
export default ApiDevProvider;